import { useEffect } from 'react';
import { Environment } from '@leagueplatform/core';

const UAT_BASE_SCRIPT_URL =
  'https://js-cdn.dynatrace.com/jstag/17ec423115e/bf21734fbt/';

const PROD_BASE_SCRIPT_URL =
  'https://js-cdn.dynatrace.com/jstag/17ec423115e/bf21220olx/';

export const useInjectDynatraceScript = (
  tenantScriptId: string | undefined,
  environment: Environment,
) => {
  useEffect(() => {
    const BASE_SCRIPT_URL =
      environment === 'production' ? PROD_BASE_SCRIPT_URL : UAT_BASE_SCRIPT_URL;
    if (tenantScriptId) {
      const dynatraceScript = document.createElement('script');
      dynatraceScript.type = 'text/javascript';
      dynatraceScript.crossOrigin = 'anonymous';
      dynatraceScript.src = `${BASE_SCRIPT_URL}${tenantScriptId}_complete.js`;
      document.head.appendChild(dynatraceScript);
    }
  }, [tenantScriptId, environment]);
};
